import { TOGGLE_ADD_ADDRESS_POPUP } from "./displayAddAddressPopupReducer"

export const toggleAddAddressPopup = (obj) => ({
    type: TOGGLE_ADD_ADDRESS_POPUP,
    payload: obj
})